import { render } from "./BaseContestProblemCard.vue?vue&type=template&id=5b427a96&ts=true"
import script from "./BaseContestProblemCard.vue?vue&type=script&lang=ts"
export * from "./BaseContestProblemCard.vue?vue&type=script&lang=ts"

import "./BaseContestProblemCard.vue?vue&type=style&index=0&id=5b427a96&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__